import React, { useState } from "react";
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";
 const scenarios = [
    {
      scenario: "Number of books read by kids in a month",
      data: [
        { category: "Alice", value: 8 },
        { category: "Bob", value: 5 },
        { category: "Cathy", value: 12 },
        { category: "David", value: 7 }
      ],
      questions: [
        { id: "q1", text: "Who read the most books?", type: "radio", options: ["Alice", "Bob", "Cathy", "David"], answer: "Cathy" },
        { id: "q2", text: "How many books did Bob read?", type: "text", answer: "5" }
      ]
    },
    {
      scenario: "Favorite ice cream flavors in a class",
      data: [
        { category: "Vanilla", value: 6 },
        { category: "Chocolate", value: 9 },
        { category: "Strawberry", value: 4 },
        { category: "Mint", value: 3 }
      ],
      questions: [
        { id: "q1", text: "Which flavor is the least popular?", type: "radio", options: ["Vanilla", "Chocolate", "Strawberry", "Mint"], answer: "Mint" },
        { id: "q2", text: "How many students like Chocolate?", type: "text", answer: "9" }
      ]
    },
    {
      scenario: "Number of pets owned by children",
      data: [
        { category: "Dogs", value: 5 },
        { category: "Cats", value: 8 },
        { category: "Birds", value: 3 },
        { category: "Fish", value: 2 }
      ],
      questions: [
        { id: "q1", text: "Which pet is most common?", type: "radio", options: ["Dogs", "Cats", "Birds", "Fish"], answer: "Cats" },
        { id: "q2", text: "How many children have dogs?", type: "text", answer: "5" }
      ]
    },
    {
      scenario: "Number of hours spent on homework by students",
      data: [
        { category: "Emma", value: 2 },
        { category: "Liam", value: 4 },
        { category: "Olivia", value: 3 },
        { category: "Noah", value: 5 }
      ],
      questions: [
        { id: "q1", text: "Who spent the least time on homework?", type: "radio", options: ["Emma", "Liam", "Olivia", "Noah"], answer: "Emma" },
        { id: "q2", text: "How many hours did Noah spend?", type: "text", answer: "5" }
      ]
    },
    {
      scenario: "Number of cars sold by salespersons in a week",
      data: [
        { category: "John", value: 7 },
        { category: "Sarah", value: 10 },
        { category: "Mike", value: 4 },
        { category: "Anna", value: 8 }
      ],
      questions: [
        { id: "q1", text: "Who sold the fewest cars?", type: "radio", options: ["John", "Sarah", "Mike", "Anna"], answer: "Mike" },
        { id: "q2", text: "How many cars did Sarah sell?", type: "text", answer: "10" }
      ]
    },
    {
      scenario: "Number of goals scored by players in a tournament",
      data: [
        { category: "Player A", value: 5 },
        { category: "Player B", value: 9 },
        { category: "Player C", value: 3 },
        { category: "Player D", value: 7 }
      ],
      questions: [
        { id: "q1", text: "Who scored the highest goals?", type: "radio", options: ["Player A", "Player B", "Player C", "Player D"], answer: "Player B" },
        { id: "q2", text: "How many goals did Player C score?", type: "text", answer: "3" }
      ]
    },
    {
      scenario: "Number of pages read by students in a week",
      data: [
        { category: "Tom", value: 20 },
        { category: "Jerry", value: 15 },
        { category: "Spike", value: 25 },
        { category: "Tyke", value: 18 }
      ],
      questions: [
        { id: "q1", text: "Who read the least pages?", type: "radio", options: ["Tom", "Jerry", "Spike", "Tyke"], answer: "Jerry" },
        { id: "q2", text: "How many pages did Spike read?", type: "text", answer: "25" }
      ]
    },
    {
      scenario: "Favorite colors of students in a class",
      data: [
        { category: "Red", value: 7 },
        { category: "Blue", value: 10 },
        { category: "Green", value: 5 },
        { category: "Yellow", value: 3 }
      ],
      questions: [
        { id: "q1", text: "Which color is the most popular?", type: "radio", options: ["Red", "Blue", "Green", "Yellow"], answer: "Blue" },
        { id: "q2", text: "How many students chose Green?", type: "text", answer: "5" }
      ]
    },
    {
      scenario: "Number of toys sold in a shop",
      data: [
        { category: "Cars", value: 14 },
        { category: "Dolls", value: 18 },
        { category: "Blocks", value: 7 },
        { category: "Balls", value: 10 }
      ],
      questions: [
        { id: "q1", text: "Which toy sold the least?", type: "radio", options: ["Cars", "Dolls", "Blocks", "Balls"], answer: "Blocks" },
        { id: "q2", text: "How many dolls were sold?", type: "text", answer: "18" }
      ]
    },
    {
      scenario: "Number of students in different classes",
      data: [
        { category: "Class 1", value: 30 },
        { category: "Class 2", value: 25 },
        { category: "Class 3", value: 28 },
        { category: "Class 4", value: 22 }
      ],
      questions: [
        { id: "q1", text: "Which class has the most students?", type: "radio", options: ["Class 1", "Class 2", "Class 3", "Class 4"], answer: "Class 1" },
        { id: "q2", text: "How many students are in Class 4?", type: "text", answer: "22" }
      ]
    },
    {
      scenario: "Number of apples harvested by farms",
      data: [
        { category: "Farm A", value: 50 },
        { category: "Farm B", value: 65 },
        { category: "Farm C", value: 45 },
        { category: "Farm D", value: 70 }
      ],
      questions: [
        { id: "q1", text: "Which farm harvested the most apples?", type: "radio", options: ["Farm A", "Farm B", "Farm C", "Farm D"], answer: "Farm D" },
        { id: "q2", text: "How many apples did Farm C harvest?", type: "text", answer: "45" }
      ]
    },
    {
      scenario: "Number of visitors to a museum over 4 days",
      data: [
        { category: "Monday", value: 120 },
        { category: "Tuesday", value: 135 },
        { category: "Wednesday", value: 110 },
        { category: "Thursday", value: 150 }
      ],
      questions: [
        { id: "q1", text: "Which day had the least visitors?", type: "radio", options: ["Monday", "Tuesday", "Wednesday", "Thursday"], answer: "Wednesday" },
        { id: "q2", text: "How many visitors came on Tuesday?", type: "text", answer: "135" }
      ]
    },
    {
      scenario: "Number of hours spent playing video games",
      data: [
        { category: "Jake", value: 6 },
        { category: "Sophia", value: 3 },
        { category: "Ethan", value: 8 },
        { category: "Mia", value: 4 }
      ],
      questions: [
        { id: "q1", text: "Who played the most hours?", type: "radio", options: ["Jake", "Sophia", "Ethan", "Mia"], answer: "Ethan" },
        { id: "q2", text: "How many hours did Sophia play?", type: "text", answer: "3" }
      ]
    },
    {
      scenario: "Number of sandwiches sold at a cafe",
      data: [
        { category: "Ham", value: 25 },
        { category: "Cheese", value: 30 },
        { category: "Chicken", value: 20 },
        { category: "Veggie", value: 15 }
      ],
      questions: [
        { id: "q1", text: "Which sandwich sold the most?", type: "radio", options: ["Ham", "Cheese", "Chicken", "Veggie"], answer: "Cheese" },
        { id: "q2", text: "How many veggie sandwiches were sold?", type: "text", answer: "15" }
      ]
    },
    {
      scenario: "Number of pencils used in classrooms",
      data: [
        { category: "Room 101", value: 45 },
        { category: "Room 102", value: 50 },
        { category: "Room 103", value: 35 },
        { category: "Room 104", value: 40 }
      ],
      questions: [
        { id: "q1", text: "Which room used the fewest pencils?", type: "radio", options: ["Room 101", "Room 102", "Room 103", "Room 104"], answer: "Room 103" },
        { id: "q2", text: "How many pencils did Room 102 use?", type: "text", answer: "50" }
      ]
    }
  ];

const colorPalette = [
  "#fefefe", "#f6f6f6", "#fff3e0", "#e0f7fa", "#fce4ec", "#e8f5e9",
];

const Scenario = ({ data, scenario, questions, bgColor, onCorrect }) => {
  const [answers, setAnswers] = useState({});
  const [feedback, setFeedback] = useState(null);

  const handleInputChange = (qId, value) => {
    setAnswers((prev) => ({ ...prev, [qId]: value }));
  };

  const checkAnswers = () => {
    const results = questions.map((q) => {
      const userAnswer = answers[q.id]?.toString().trim();
      return userAnswer === q.answer.toString();
    });
    const allCorrect = results.every(Boolean);
    setFeedback(allCorrect ? "✅ All answers are correct!" : "❌ Some answers are incorrect. Try again!");

    if (allCorrect && onCorrect) {
      setTimeout(() => {
        onCorrect();
      }, 1000); // Delay before showing the next scenario
    }
  };

  return (
    <div
      className="scenario-block"
      style={{
        backgroundColor: bgColor,
        padding: 20,
        borderRadius: 10,
        marginBottom: 30,
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    >
      <h3 style={{ marginBottom: 15 ,textAlign:"center"}}>{scenario}</h3>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: 20,
        }}
      >
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "8px" }}>Category</th>
            <th style={{ border: "1px solid #ccc", padding: "8px" }}>Value</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, idx) => (
            <tr key={idx}>
              <td style={{ border: "1px solid #ccc", padding: "8px" ,textAlign:"center"}}>{item.category}</td>
              <td style={{ border: "1px solid #ccc", padding: "8px" ,textAlign:"center"}}>{item.value}</td>
            </tr>
          ))}
        </tbody>
      </table>

<div
  className="questions"
  style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
>
  {questions.map((q) => (
    <div key={q.id} style={{ marginBottom: 15, textAlign: "center" }}>
      <strong>{q.text}</strong>
      <div style={{ marginTop: 5 }}>
        {q.type === "radio" ? (
          q.options.map((opt, i) => (
            <label key={i} style={{ marginRight: 15 }}>
              <input
                type="radio"
                name={q.id}
                value={opt}
                checked={answers[q.id] === opt}
                onChange={() => handleInputChange(q.id, opt)}
                style={{ marginRight: 5 }}
              />
              {opt}
            </label>
          ))
        ) : (
          <input
            type="text"
            value={answers[q.id] || ""}
            onChange={(e) => handleInputChange(q.id, e.target.value)}
            style={{
              padding: "6px 10px",
              fontSize: "1em",
              width: "200px",
              marginTop: 5,
              borderRadius: 5,
              border: "1px solid #ccc",
              marginLeft:"1rem"
            }}
          />
        )}
      </div>
    </div>
  ))}

  <button
    onClick={checkAnswers}
    style={{
      marginTop: 20,
      padding: "10px 20px",
      fontSize: "1em",
      backgroundColor: "#2a5d9f",
      color: "#fff",
      border: "none",
      borderRadius: 6,
      cursor: "pointer",
    }}
  >
    Check Answers
  </button>
</div>


      {feedback && (
        <div style={{ marginTop: 15, fontWeight: "bold", fontSize: "1.1em" }}>
          {feedback}
        </div>
      )}
    </div>
  );
};

const DataInterpretationPractice = () => {
  const [visibleIndex, setVisibleIndex] = useState(0);

  const showNextScenario = () => {
    const isLastScenario = visibleIndex === scenarios.length - 1;
  
  if (isLastScenario) {
    const responsedata = ConstructorEventUpdateSQLStatus();
    console.log("Event completed", responsedata);
  } else {
    setVisibleIndex((prev) => prev + 1);
  }
  };

  return (
    <div style={{ fontFamily: "'Comic Neue', cursive", padding: 20, background: "#f0f4f8" }}>
      <h3 style={{ textAlign: "center", color: "#2a5d9f" }}>📚 Data Interpretation Practice</h3>
      {scenarios.slice(0, visibleIndex + 1).map((scenario, idx) => (
        <Scenario
          key={idx}
          {...scenario}
          bgColor={colorPalette[idx % colorPalette.length]}
          onCorrect={showNextScenario}
        />
      ))}
    </div>
  );
};

export default DataInterpretationPractice;
